import { ProjectProfile } from '../../../models/projects.model';
import { UserIs, UserTags } from '../../../models/user-is.model';
// eslint-disable-next-line import/no-cycle
import { MenuType } from '../../../app.menu';

export const accessRulesConfig = {
  components: {
    header: {
      show: {
        section: {
          release_info: [ProjectProfile.UTMC],
        },
        logo: {
          miia: [ProjectProfile.UTMC],
        },
      },
    },
    support_modal: {
      show: {
        section: {
          contact_us: [ProjectProfile.UTMC],
          help_center: [UserIs.INTERNAL, UserIs.CLIENT],
        },
      },
    },
  },
  common: {
    register: {
      show: {
        registration_video_tutorial_link: [ProjectProfile.UTMC],
      },
    },
    login: {
      show: {
        first_login_modal: [UserIs.INTERNAL, UserIs.CLIENT],
      },
    },
  },
  cms: {
    companies: {
      list: {
        show: {
          header_buttons: true,
        },
      },
    },
    case: {
      list: {
        show: {
          filter: {
            partner_program: {
              [ProjectProfile.UTMC]: [UserIs.INTERNAL, UserIs.PARTNER],
              [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL],
            },
          },
        },
      },
    },
    sides: {
      list: {
        show: {
          element: {
            button: {
              header: {
                create: [ProjectProfile.UTMC],
              },
            },
          },
        },
      },
    },
    benefit_charge: {
      list: {
        show: {
          element: {
            button: {
              header: {
                reports: [ProjectProfile.UTMC],
              },
            },
          },
          filter: {
            partner_program: {
              [ProjectProfile.UTMC]: [],
              [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL],
            },
          },
        },
      },
    },
    benefit_charges_report: {
      common: {
        show: {
          element: {
            header: {
              export_to_excel: [ProjectProfile.UTMC],
            },
          },
        },
      },
    },
    help: {
      common: {
        show: {
          section: {
            video_tutorials: { [ProjectProfile.UTMC]: [], [ProjectProfile.STOPCLAIMS]: [] },
          },
        },
      },
    },
  },
  cm: {
    clients: {
      export: {
        show: {
          filter: {
            partner_program: {
              [ProjectProfile.UTMC]: [],
              [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL],
            },
          },
        },
      },
      common: {
        show: {
          field: {
            reference: [ProjectProfile.UTMC],
            partner_program: {
              [ProjectProfile.UTMC]: [],
              [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL],
            },
          },
          tab: {
            contract: [ProjectProfile.UTMC],
            introduction_letter: [ProjectProfile.UTMC],
          },
        },
      },
      list: {
        show: {
          filter: {
            partner_program: {
              [ProjectProfile.UTMC]: [],
              [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL],
            },
          },
        },
      },
    },
    personnel: {
      edit: {
        show: {
          section: {
            tags_help_tooltip: [ProjectProfile.STOPCLAIMS],
          },
        },
      },
    },
  },
  menu: {
    [MenuType.CLIENTS]: [UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.PERSONNEL]: [UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.CLIENT_DOCUMENTS]: [UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.CLIENT_REPORTS]: [UserIs.CM.BILL_MGR],
    [MenuType.CONTRACTS_AND_RENEWALS]: [UserIs.CM.BILL_MGR],
    [MenuType.INVOICES]: [UserIs.CM.TLE],
    [MenuType.STATEMENTS]: [UserIs.CM.TLE],
    [MenuType.PAYMENTS]: [UserIs.CM.TLE],
    [MenuType.BILLING_REPORTS]: [UserIs.CM.TLE, UserIs.CM.BILL_MGR],
    [MenuType.PROTESTS]: [UserIs.INTERNAL],
    [MenuType.STATEMENTS_OF_ACCOUNT]: [UserIs.INTERNAL, UserIs.PARTNER],
    [MenuType.RATE_NOTICES]: [UserIs.INTERNAL],
    [MenuType.ACTIVITIES]: [UserIs.INTERNAL.ADMIN, UserIs.INTERNAL.ANALYST],
    [MenuType.ACTIVITIES_BENEFIT_CHARGES]: [UserIs.INTERNAL.ADMIN],
    [MenuType.ACTIVITIES_RATE_NOTICES]: [UserIs.INTERNAL],
    [MenuType.ACTIVITIES_MAILING_LABELS]: [UserIs.INTERNAL],
    [MenuType.REPORTS_ANNUAL_PAGES]: [UserIs.INTERNAL, UserIs.CLIENT.GC, UserIs.CLIENT.AM],
    [MenuType.ANALYTICS]: [UserIs.INTERNAL.ADMIN],
    [MenuType.SETTINGS_DATA]: [UserIs.INTERNAL.ADMIN],
    [MenuType.CLAIMANTS]: [UserIs.INTERNAL],
    [MenuType.DASHBOARD]: [UserIs.CLIENT, UserIs.INTERNAL],
    [MenuType.COMPANIES]: [UserIs.INTERNAL, UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.COMPANY]: [UserIs.INTERNAL, UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.CONTACTS]: [UserIs.CM.CLIENT_MGR, UserIs.CM.CLIENT_VIEW_ONLY],
    [MenuType.CASES]: [UserIs.INTERNAL, UserIs.CLIENT.AM, UserIs.CLIENT.GC, UserIs.PARTNER],
    [MenuType.SIDES]: [UserIs.INTERNAL.ADMIN],
    [MenuType.BENEFIT_CHARGES]: [UserIs.INTERNAL, UserIs.PARTNER],
    [MenuType.DOCUMENTS]: [
      UserIs.INTERNAL,
      UserIs.CLIENT,
      UserIs.CM.CLIENT_MGR,
      UserIs.CM.CLIENT_VIEW_ONLY,
    ],
    [MenuType.REPORTS_UI_ACTIVITY_REPORT]: [UserIs.INTERNAL, UserIs.CLIENT],
    [MenuType.REPORTS_RATE_NOTICES]: [UserIs.INTERNAL],
    [MenuType.REPORTS_PARTNER_PROGRAMS]: [UserIs.INTERNAL, UserIs.PARTNER],
    [MenuType.SETTINGS]: [UserIs.INTERNAL.ADMIN, UserIs.CLIENT.AM],
    [MenuType.SETTINGS_INTERNAL_USERS]: [UserIs.INTERNAL.ADMIN],
    [MenuType.SETTINGS_ANALYSTS_ASSIGNED]: [UserIs.INTERNAL.ADMIN],
    [MenuType.SETTINGS_PARTNER_PROGRAMS]: [UserIs.INTERNAL.ADMIN],
    [MenuType.SETTINGS_AUTHORIZE_ACCESS]: [UserIs.CLIENT.AM],
    [MenuType.TOOLS]: [UserIs.INTERNAL],
    [MenuType.TOOLS_LETTER_TEMPLATES]: [UserIs.INTERNAL],
    [MenuType.HELP]: [UserIs.INTERNAL, UserIs.CLIENT],
    [MenuType.ABOUT]: [UserIs.INTERNAL],

    [MenuType.REPORTS]: {
      [ProjectProfile.UTMC]: [
        UserIs.INTERNAL,
        UserIs.CLIENT,
        UserIs.PARTNER,
        UserIs.CLIENT?.GC,
        UserIs.CLIENT?.AM,
      ],
      [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL, UserIs.CLIENT, UserIs.PARTNER],
    },
    [MenuType.REPORTS_BENEFIT_CHARGES]: {
      [ProjectProfile.UTMC]: [],
      [ProjectProfile.STOPCLAIMS]: [UserIs.INTERNAL, UserIs.PARTNER],
    },
    [MenuType.BILLING]: {
      [ProjectProfile.UTMC]: [
        {
          roles: [UserIs.INTERNAL.ANALYST],
          tags: [],
        },
        {
          roles: [UserIs.CLIENT],
          tags: [UserTags.BILL, UserTags.BILL_],
        },
      ],
    },
    [MenuType.SETTINGS_SECURITY]: [UserIs.INTERNAL.ADMIN],
  },
  models: {
    cms_report_benefit_charges: {
      // available_report_types: {
      //   internal: {
      //     [ProjectProfile.UTMC]: [
      //       'charge_history_report',
      //       'protestable_bc_per_state_program',
      //       'covid_charges_and_credits',
      //       'protest_fact_finding_timeliness',
      //       'missing_benefit_charge_statements_report',
      //       'fraudulent_claim_charges',
      //       'protestable_benefit_charges_report',
      //       'bills_and_statements_net_totals',
      //       'bills_and_statements_copies',
      //       'remaining_liability',
      //     ],
      //     [ProjectProfile.DEFAULT]: [
      //       'protestable_benefit_charges_report',
      //       'bills_and_statements_net_totals',
      //       'bills_and_statements_copies',
      //     ],
      //   },
      //   partner: {
      //     [ProjectProfile.UTMC]: [
      //       'charge_history_report',
      //       'bills_and_statements_net_totals',
      //       'bills_and_statements_copies',
      //       'fraudulent_claim_charges',
      //     ],
      //     [ProjectProfile.DEFAULT]: [
      //       'charge_history_report',
      //       'bills_and_statements_net_totals',
      //       'bills_and_statements_copies',
      //     ],
      //   },
      // },
      default_report_types: {
        common: {
          [ProjectProfile.UTMC]: 'charge_history_report',
          [ProjectProfile.DEFAULT]: 'protestable_benefit_charges_report',
        },
        employer: {
          [ProjectProfile.UTMC]: 'charge_history_report',
          [ProjectProfile.DEFAULT]: 'charge_history_report',
        },
      },
    },
  },
};
